import {FC} from 'react'
import {API_ROOT, fixNumbers} from '../../../../_metronic/helpers'

export type CaptchaStore = {
  token: string
  captcha: string
}
const CAPTCHA_URL = `${API_ROOT}/home/captcha`

const createCaptchaToken = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`

const createCaptchaStore = (): CaptchaStore => ({
  token: createCaptchaToken(),
  captcha: '',
})

type Props = {
  value: CaptchaStore
  onChange: (captcha: CaptchaStore) => void
  disabled?: boolean
  error?: string
  onEnter?: () => void
}

const LoginCaptcha: FC<Props> = ({value, onChange, disabled = false, error, onEnter}) => {
  const refreshCaptcha = () => {
    if (disabled) return
    onChange(createCaptchaStore())
  }

  const setCaptchaValue = (nextValue: string) => {
    const nextCaptcha = fixNumbers(nextValue).replace(/\D/g, '').slice(0, 4)
    onChange({...value, captcha: nextCaptcha})
  }

  return (
    <div className='fv-row mb-8'>
      <label className='form-label fs-6 fw-bolder text-dark'>کد امنیتی</label>
      <div className='login-captcha'>
        <button
          type='button'
          className='login-captcha__refresh'
          onClick={refreshCaptcha}
          disabled={disabled}
          aria-label='تغییر کد امنیتی'
          title='کد جدید'
        >
          <i className='las la-redo-alt' aria-hidden='true' />
          <span>کد جدید</span>
        </button>
        <div className='login-captcha__image'>
          <img
            src={`${CAPTCHA_URL}?t=${encodeURIComponent(value.token)}`}
            alt='کد امنیتی'
            onClick={refreshCaptcha}
          />
        </div>
        <input
          className='form-control bg-transparent text-center'
          type='text'
          inputMode='numeric'
          pattern='\d*'
          maxLength={4}
          autoComplete='off'
          dir='ltr'
          value={value.captcha}
          disabled={disabled}
          placeholder='----'
          aria-label='ورود کد امنیتی'
          onChange={(event) => setCaptchaValue(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && onEnter) {
              event.preventDefault()
              onEnter()
            }
          }}
        />
      </div>
      {error && (
        <div className='fv-plugins-message-container'>
          <span role='alert'>{error}</span>
        </div>
      )}
    </div>
  )
}

export {LoginCaptcha, createCaptchaStore}
